import { groupsApi } from '@/shared/redux/api/assets/groups/groups-api';
import { identApi } from '@/shared/redux/api/ident/ident-api';
import { integrationsApi } from '@/shared/redux/api/integration/integrations-api';
import { jobsApi } from '@/shared/redux/api/jobs/jobs-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';
import {
  ReadGroupedAssetsCountQuery,
  ReadGroupedIdentitiesCountQuery,
  ReadGroupedIntegrationsCountQuery,
  ReadGroupedPipelinesCountQuery,
} from '@/shared/types/types.generated';

const computeAllResourcesCount = (
  assets: ReadGroupedAssetsCountQuery | undefined,
  identities: ReadGroupedIdentitiesCountQuery | undefined,
  pipelines: ReadGroupedPipelinesCountQuery | undefined,
  integrations: ReadGroupedIntegrationsCountQuery | undefined,
) =>
  (assets?.readSubGroupsForResourceGroup?.itemCount ?? 0) +
  (assets?.readAllDevices?.itemCount ?? 0) +
  (assets?.readAllProjects?.itemCount ?? 0) +
  (assets?.readAllGateways?.itemCount ?? 0) +
  (assets?.readAllDocuments?.itemCount ?? 0) +
  (assets?.readAllVaults?.itemCount ?? 0) +
  (assets?.readAllLicenses?.itemCount ?? 0) +
  (identities?.readAllUsers?.itemCount ?? 0) +
  (identities?.readAllUserRoles?.itemCount ?? 0) +
  (pipelines?.readAllPipelineConfigurations?.itemCount ?? 0) +
  (integrations?.readAllIntegrations?.itemCount ?? 0);

export const useGroupsResourcesCount = (groupIds: string[]) =>
  useAppSelector((state) =>
    Object.fromEntries(
      groupIds.map((groupId) => {
        const assets = groupsApi.endpoints.ReadGroupedAssetsCount.select({
          groupId,
        })(state);
        const identities = identApi.endpoints.ReadGroupedIdentitiesCount.select(
          { groupId },
        )(state);
        const pipelines = jobsApi.endpoints.ReadGroupedPipelinesCount.select({
          groupId,
        })(state);
        const integrations =
          integrationsApi.endpoints.ReadGroupedIntegrationsCount.select({
            groupId,
          })(state);

        return [
          groupId,
          {
            allResourcesCount: computeAllResourcesCount(
              assets.data,
              identities.data,
              pipelines.data,
              integrations.data,
            ),
            isLoading:
              assets.isLoading ||
              identities.isLoading ||
              pipelines.isLoading ||
              integrations.isLoading,
          },
        ];
      }),
    ),
  );
